import React, { Fragment } from 'react'

import yn from 'yn'

const BkFlowEnhancementsCardDescription = props => {
	const {
		serviceDescription,
		serviceDescriptionExpanded,
		limitChars,
	} = props

	return (
		<div className="bk-flow-enhancements__card-description">
			{ yn(process.env.REACT_APP_COMPONENT_ENHANCEMENTS_DESCRIPTION_ACCORDION) &&
				serviceDescription.length > limitChars ?
				<Fragment>
					{ serviceDescription.slice(0, limitChars) }
					<span className={
						serviceDescriptionExpanded ?
							'u-txt-read-more expanded'
						:
							'u-txt-read-more'
					}>
						{ serviceDescription.slice(limitChars) }
					</span>
				</Fragment>
			:
				serviceDescription
			}
		</div>
	)
}

export default BkFlowEnhancementsCardDescription


// WEBPACK FOOTER //
// ./src/components/enhancements/elements/BkFlowEnhancementsCardDescription.js